module.exports = __webpack_public_path__ + "static/media/CTLI_11-293w.87d8729c.webp";